import React from "react";
import { withRouter } from "react-router-dom";
import emailjs from 'emailjs-com';
import Reveal from 'react-reveal/Reveal';

import SimpleMap from '../components/Map';
import Footer from '../components/Footer';

import { Efect, Efect1, Efect2  } from "../styles/effect.styles";
  

const Contact = ({ history }) => {

    function sendEmail(e) {
    const success = document.getElementById("success");
    const button = document.getElementById("buttonsent");
    const failed = document.getElementById("failed");
    e.preventDefault();

    emailjs.sendForm('service_a41olen', 'template_uue2d5n', e.target, 'SmxfcHKYYbf1RpvUs')
      .then((result) => {
          console.log(result.text);
          success.classList.add('show');
          button.classList.add('show');
          failed.classList.remove('show');
      }, (error) => {
          console.log(error.text);
          failed.classList.add('show');
      });
  }  

  return (
    <div>
      <Efect/>
      <Efect1/>
      <Efect2/>

      <div className="jumbotron head"/>

      <Reveal effect="fadeInUp">
       <section className='container'>
          <div className='row'>
            <div className='col-12'>
              <h1>Get in touch with me to <br/> <span className='color' style={{ color:'#FED8A6'}}>optimize</span> your health</h1>
            </div>
          </div>
        </section>
      </Reveal>

      <Reveal effect="fadeInUp">
       <section className='container pt-0'>
          <div className='row'>
            <div className='col-12'>
              {/* <SimpleMap/> */}
            </div>
            <div className='col-md-6'>
            <div className="text-side">
              <h3 className="heading">Ready to begin? </h3>
              <p>If you are ready to begin optimizing your health and 
                discovering your true potential, please send me a message, or "Book Now",
                to begin your individualized health journey. 
              </p>
              <div className='address'>
                <h6 style={{ color: "#92ADA4" }}>British Columbia</h6>
                <div className='list'>
                  <i className="fa fa-map-marker"style={{ color: "#92ADA4" }}></i>
                  847 Hornby St. Vancouver, BC, Canada
                </div>
                <div className='list'>
                  <i className="fa fa-envelope-o"style={{ color: "#92ADA4" }}></i>
                  <a href='mailto:contact_info@homekins.com' target='_blank' rel='noopener noreferrer'>
                    drmichellemaliknd@gmail.com
                  </a>
                </div>
                <div className='list'>
                  <i className="fa fa-phone"style={{ color: "#92ADA4" }}></i>
                  (604) 684-0544
                </div>
                <h6 style={{ color: "#92ADA4", marginTop: "24px" }}>California</h6>
                <div className='list'>
                  <i className="fa fa-map-marker"style={{ color: "#92ADA4" }}></i>
                  6310 San Vicente Blvd # 107, Los Angeles, CA, USA
                </div>
                <div className='list'>
                  <i className="fa fa-envelope-o"style={{ color: "#92ADA4" }}></i>
                  <a href='mailto:contact_info@homekins.com' target='_blank' rel='noopener noreferrer'>
                    drmichellemaliknd@gmail.com
                  </a>
                </div>
                <div className='list'>
                  <i className="fa fa-phone"style={{ color: "#92ADA4" }}></i>
                  (323) 879-9555
                </div>
                <div>
                <a
                  href="https://drmichellendstudeogyms.janeapp.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-block",
                    margin: "2rem 0 1rem",
                    padding: "0.75rem 1.5rem",
                    border: "2px solid #FED8A6",
                    color: "#DAA38F",
                    borderRadius: "8px",
                    textDecoration: "none",
                    fontWeight: "bold",
                    backgroundColor: "transparent",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#92ADA4";
                    e.target.style.color = "#fff";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#DAA38F";
                  }}
                >
                  Book Now
                </a>
                </div>
                </div>
              </div>
            </div>

            <div className='col-md-6'>
            <div className="form-side">
              <form className="formcontact" onSubmit={sendEmail}>
                <label>Name</label>
                <input type="text" name="user_name" required />
                <label>Email</label>
                <input type="email" name="user_email" required />
                <label>Message</label>
                <textarea name="message" required />
                <div id='success' className='hide'>Your message has been sent...</div>
                <div id='failed' className='hide'>Message failed...</div>
                <button type="submit" id='buttonsent'>
                  <span className="shine"></span>
                  <span>Send</span>
                </button>
              </form>
            </div>
          </div>


          </div>
       </section>
      </Reveal>

      

      <Footer />

    </div>
    
  );
};

export default withRouter(Contact);
